import React from 'react';
import { MenuItem } from './components';
import { AlyzeOptimizedImage } from '@/utilities/AlyzeOptimizedImage';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
  menuRef?: React.RefObject<HTMLDivElement>;
}

export const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, onClose, menuRef }) => {
  return (
    <>
      <style>{`
        .mobile-menu-container {
          background-color: #000000;
          max-height: ${isOpen ? 'calc(100vh - 70px)' : '0'};
          height: ${isOpen ? 'calc(100vh - 70px)' : '0'};
          opacity: ${isOpen ? 1 : 0};
        }
        @media (min-width: 768px) {
          .mobile-menu-container {
            max-height: ${isOpen ? '400px' : '0'} !important;
            height: ${isOpen ? '400px' : '0'} !important;
          }
        }
      `}</style>
      <div
        ref={menuRef}
        className="mobile-menu-container w-full fixed left-0 top-[70px] z-40 overflow-hidden transition-all duration-500 ease-in-out md:top-[67px]"
      >
        <div className="flex flex-col md:flex-row md:relative p-2 md:p-0 h-full">
        {/* Menu Items */}
        <div className="flex flex-col items-start mb-6 md:mb-0 md:absolute md:left-[110px] md:top-1/2 md:-translate-y-1/2 px-4 md:px-0" style={{ paddingTop: '16px' }}>
          <MenuItem href="/alyze-membership-waitlist" onClick={onClose}>Join the Waitlist</MenuItem>
          <MenuItem href="/#whole-solution" onClick={onClose}>Services</MenuItem>
        </div>

        {/* Menu images - stacked on mobile, horizontal on desktop */}
        <div className="flex flex-col md:flex-row gap-0 md:gap-[67px] md:pl-[606px] md:pt-[26px] md:pb-[26px] w-full items-center md:items-start">
          <div style={{ padding: '8px 16px' }} className="w-full md:w-auto">
            <AlyzeOptimizedImage 
              src="layouts/_header/couple-in-sauna.jpg"
              alt="Couple in sauna"
              width={267}
              height={206}
              className="rounded-[32px] w-full h-auto md:w-[400px]"
            />
          </div>
          <div style={{ padding: '8px 16px' }} className="w-full md:w-auto">
            <AlyzeOptimizedImage 
              src="layouts/_header/man-chest-extensions.jpg"
              alt="Man doing chest extensions"
              width={486}
              height={206}
              className="rounded-[32px] w-full h-auto md:w-[729px]"
            />
          </div>
        </div>
      </div>
    </div>
    </>
  );
};
